export const AUTH_PATH = "auth";

/**
 * FIXME remove these inner auth links once we finish launching v2
 */
export const AUTH_LOGIN_PATH = "auth/login";
export const AUTH_SIGN_UP_PATH = "auth/sign-up";
